var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlTableManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6654 7.3335V10.0002H24.6654V14.0002H21.9987V10.0002H17.9987V7.3335H21.9987V3.3335H24.6654V7.3335H28.6654ZM24.6654 26.0002H5.9987V7.3335H13.9987V4.66683H5.9987C4.53203 4.66683 3.33203 5.86683 3.33203 7.3335V26.0002C3.33203 27.4668 4.53203 28.6668 5.9987 28.6668H24.6654C26.132 28.6668 27.332 27.4668 27.332 26.0002V18.0002H24.6654V26.0002ZM19.332 18.0002V23.3335H21.9987V18.0002H19.332ZM13.9987 23.3335H16.6654V12.6668H13.9987V23.3335ZM11.332 23.3335V15.3335H8.66536V23.3335H11.332Z",
    fill: "#00579C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlTableManagement);
export default __webpack_public_path__ + "static/media/ControlTableManagement.8af074d455f29dab595f446624a6f17c.svg";
export { ForwardRef as ReactComponent };